import React from 'react';
import bem from '../../../../lib/bemUtils/bem';
import { SVG, SVGIcon } from '../../../../components/atoms/SVG';

import { getFileIcon } from './DownloadFileIcon.utils';
import { Modifier } from '../../../../lib/bemUtils/Modifier';

export enum DownloadFileIconModifier {
  RELATIVE = 'relative',
  SMALL = 'small',
}

type DownloadFileIcon = {
  modifier?: Modifier<DownloadFileIconModifier>;
  fileExtension: string;
};

type FileIcon = {
  svgSprite: SVGIcon;
  modifier?: Modifier<DownloadFileIconModifier>;
  className?: string;
};

/**
 * Generic Icon Component for Files and Structure Icons.
 */
export function FileIcon({ modifier, svgSprite, className }: FileIcon) {
  return (
    <span className={bem('download-file-icon', modifier)}>
      <SVG svgSpriteId={svgSprite} svgClass={className} />
    </span>
  );
}

/**
 * Icon representing a File by its extension.
 */
export function DownloadFileIcon({ modifier, fileExtension }: DownloadFileIcon) {
  const { iconFileName, className } = getFileIcon(fileExtension);
  return <FileIcon className={className} modifier={modifier} svgSprite={iconFileName} />;
}
